export enum ComType {
    DIRECT_MESSAGE = 1,
    EMAIL = 2
}